import { Link, useLocation } from "react-router-dom";
const NotFound = () => {

    const attemptedPath = useLocation().pathname;

    return (
        <>
            <div style={{ minHeight: "calc(100vh - 240px)", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--compass-gradient)" }}>

                <div className="container text-center">

                    <div style={{ maxWidth: "640px", margin: "0 auto", padding: "48px 36px", borderRadius: "18px", background: "rgba(255,255,255,0.08)", backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)", border: "1px solid rgba(255,255,255,0.18)", boxShadow: "0 30px 80px rgba(0,0,0,0.35)" }}>

                        <div style={{ fontSize: "88px", fontWeight: 800, lineHeight: 1, color: "rgba(255,255,255,0.9)", letterSpacing: "-2px" }}>
                            404
                        </div>

                        <div style={{ fontSize: "26px", fontWeight: 700, color: "white", marginTop: "8px" }}>
                            Page Coming Soon
                        </div>

                        <div style={{ marginTop: "6px", fontSize: "18px", color: "rgba(255,255,255,0.25)", fontStyle: "italic" }}>
                            {attemptedPath}
                        </div>

                        <div style={{ marginTop: "14px", opacity: 0.92, color: "rgba(255,255,255,0.92)", lineHeight: 1.6 }}>
                            This destination has already been mapped into the site, but the full page is still being built out.
                        </div>

                        <div style={{ marginTop: "12px", opacity: 0.82, color: "rgba(255,255,255,0.82)", lineHeight: 1.6 }}>
                            In the meantime, you can head back home, keep browsing, or contact C+M Baling Systems directly.
                        </div>

                        <div style={{ marginTop: "28px", display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
                            <Link to="/" className="btn btn-info" style={{ borderRadius: "999px", padding: "10px 18px", fontWeight: 600 }}>
                                Return Home
                            </Link>

                            <Link to="/contact/general-inquiry" className="btn btn-outline-light" style={{ borderRadius: "999px", padding: "10px 18px", fontWeight: 600 }}>
                                Contact
                            </Link>

                        </div>

                    </div>

                </div>

            </div>

        </>
    );
};

export default NotFound;
